import { render } from "./DTProfesores.vue?vue&type=template&id=fbe78e14"
import script from "./DTProfesores.vue?vue&type=script&lang=js"
export * from "./DTProfesores.vue?vue&type=script&lang=js"

import "./DTProfesores.vue?vue&type=style&index=0&id=fbe78e14&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__